import type { IconProps } from './types/types';

const GooglePlayStoreIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2242 8.09625L4.64334 2.05574C4.51039 1.97862 4.34312 1.98291 4.21445 2.06002C4.08149 2.13713 4 2.27422 4 2.42845C4 2.42845 4.00429 2.98538 4.00858 3.90216L11.7158 11.6006L15.2242 8.09625Z"
      fill="url(#paint0_linear_2184_96097)"
    />
    <path
      d="M4.00867 3.90283C4.02153 7.21012 4.06013 15.2384 4.07729 19.2354L11.7202 11.6013L4.00867 3.90283Z"
      fill="url(#paint1_linear_2184_96097)"
    />
    <path
      d="M21.2804 11.5534L15.2244 8.09619L11.7117 11.6005L15.6747 15.559L21.2847 12.2946C21.4176 12.2174 21.4991 12.0761 21.4991 11.9261C21.4991 11.7719 21.4133 11.6305 21.2804 11.5534Z"
      fill="url(#paint2_linear_2184_96097)"
    />
    <path
      d="M4.073 19.2349C4.08158 20.6615 4.08586 21.574 4.08586 21.574C4.08586 21.7282 4.16735 21.8696 4.30031 21.9424C4.43327 22.0195 4.59625 22.0195 4.72921 21.9424L15.6789 15.5634L11.7159 11.605L4.073 19.2349Z"
      fill="url(#paint3_linear_2184_96097)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2184_96097"
        x1="4"
        y1="6.80221"
        x2="15.2262"
        y2="6.80221"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#63BE6B" />
        <stop offset="0.506" stopColor="#5BBC6A" />
        <stop offset="1" stopColor="#4AB96A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2184_96097"
        x1="4.00661"
        y1="11.571"
        x2="11.7157"
        y2="11.571"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3EC6F2" />
        <stop offset="1" stopColor="#45AFE3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2184_96097"
        x1="11.7158"
        y1="11.8303"
        x2="21.4981"
        y2="11.8303"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAA51A" />
        <stop offset="0.387" stopColor="#FAB716" />
        <stop offset="0.741" stopColor="#FAC412" />
        <stop offset="1" stopColor="#FAC80F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2184_96097"
        x1="4.07489"
        y1="16.8024"
        x2="15.6787"
        y2="16.8024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EC3B50" />
        <stop offset="1" stopColor="#E7515B" />
      </linearGradient>
    </defs>
  </svg>
);

export default GooglePlayStoreIcon;
